module.exports = __webpack_public_path__ + "img/copa-prosa-logo-2024.75816c89.png";